import { FEATURED_SCOOP } from '@/mocks/scoopRequests';
import SectionHeading from './SectionHeading';

export default function FeaturedSection() {
  return (
    <section className="relative border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          index="01"
          kicker="寻料头条 · 编辑部重点"
          title="今日最受关注的征集令"
          sub="线索越具体、可核验程度越高，越容易进入深度求证。先看这一条编辑部重点推进的征集。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* left index plate */}
          <div className="relative order-2 lg:order-1 lg:col-span-5">
            <div className="flex h-full flex-col justify-between overflow-hidden rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <div>
                <div className="flex items-center gap-3">
                  <span className="flex h-14 w-14 items-center justify-center rounded-md bg-primary-500 font-heading text-2xl font-black text-background-50">
                    XL
                  </span>
                  <div>
                    <p className="text-[12px] font-semibold tracking-widest text-foreground-500">征集令编号</p>
                    <p className="font-heading text-xl font-bold text-foreground-950">{FEATURED_SCOOP.num}</p>
                  </div>
                </div>
                <dl className="mt-6 space-y-3 border-t border-background-200 pt-5 text-[14px]">
                  <div className="flex items-center justify-between gap-4">
                    <dt className="flex items-center gap-2 text-foreground-600">
                      <i className="ri-price-tag-3-line text-accent-600" aria-hidden="true"></i>征集类型
                    </dt>
                    <dd className="font-semibold text-foreground-900">{FEATURED_SCOOP.category}</dd>
                  </div>
                  <div className="flex items-center justify-between gap-4">
                    <dt className="flex items-center gap-2 text-foreground-600">
                      <i className="ri-user-voice-line text-accent-600" aria-hidden="true"></i>征集对象
                    </dt>
                    <dd className="font-semibold text-foreground-900">大促下单用户</dd>
                  </div>
                  <div className="flex items-center justify-between gap-4">
                    <dt className="flex items-center gap-2 text-foreground-600">
                      <i className="ri-file-list-3-line text-accent-600" aria-hidden="true"></i>已有独立线索
                    </dt>
                    <dd className="font-heading text-lg font-bold text-primary-700">{FEATURED_SCOOP.leads} 条</dd>
                  </div>
                </dl>
              </div>
              <div className="mt-6 flex flex-col gap-2.5 sm:flex-row">
                <a
                  href="#submit"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-send-plane-line" aria-hidden="true"></i>去提供这条料
                </a>
                <a
                  href="#verify"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  进入求证工作台
                </a>
              </div>
            </div>
          </div>

          {/* right feature article */}
          <article className="relative order-1 lg:order-2 lg:col-span-7">
            <div className="editorial-rule absolute inset-x-0 top-0 h-1 rounded-full" aria-hidden="true"></div>
            <div className="h-full rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-1 text-[12px] font-bold text-background-50">
                  <i className="ri-fire-fill" aria-hidden="true"></i>热度 {FEATURED_SCOOP.urgency}
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[12px] font-semibold text-secondary-900">
                  {FEATURED_SCOOP.category}
                </span>
                <span className="flex items-center gap-1 text-[12px] text-foreground-500">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {FEATURED_SCOOP.deadline}
                </span>
              </div>

              <h3 className="mt-5 font-heading text-xl font-black leading-snug text-foreground-950 md:text-3xl">
                {FEATURED_SCOOP.title}
              </h3>
              <p className="mt-3 text-[14px] font-semibold text-foreground-700">
                面向：{FEATURED_SCOOP.target}
              </p>
              <p className="mt-3 max-w-3xl text-[15px] leading-relaxed text-foreground-600">
                {FEATURED_SCOOP.desc}
              </p>

              <div className="mt-6 flex flex-wrap items-center justify-between gap-3 rounded-md border border-background-200 bg-background-100 px-4 py-3">
                <div className="flex items-center gap-2 text-[13px] text-foreground-600">
                  <i className="ri-shield-check-line text-primary-600" aria-hidden="true"></i>
                  来源：{FEATURED_SCOOP.source} · 提供者信息将脱敏
                </div>
                <a href="#board" className="flex items-center gap-1 text-[13px] font-semibold text-primary-700 hover:text-primary-800">
                  看同类征集 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}